import { Box, Grid, Tooltip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";
import { BentoBrand } from "schemas/dashboard";

import { getIconsCondition } from "../DetailedBrandView/helpers";

const styles = {
  icon: {
    fontSize: { xs: 14 },
    mx: 0.5,
  },
  paidPartnershipBadge: {
    color: "#32885F",
  },
  worksWithUgcBadge: {
    color: "#388BED",
  },
  worksWithInfluencer: {
    color: "#D45FD1",
  },
  bolt: {
    color: "#786EEB",
  },
  star: {
    color: "#EDDB38",
  },
  locationPin: {
    color: "#CE6868",
  },
  tiktok: {
    color: "#010101",
  },
  directContact: {
    color: "#F6BB75",
  },
  ads: {
    color: "#F15E5E",
  },
  tag: {
    fontSize: 12,
    color: grey[600],
    textTransform: "capitalize",
  },
};

interface Props {
  bentoBrand: BentoBrand;
}

export default function BrandIcons({ bentoBrand }: Props) {
  const { profile } = useContext(OrganizationUserContext);

  const {
    addedWithinLastWeek,
    hasPaidPartnership,
    worksWithUgc,
    worksWithInfluencer,
    noRecentContacts,
    hasTiktokAds,
    hasNonGenericEmails,
    hasAds,
    worksWithPodcasters,
  } = getIconsCondition(bentoBrand);

  const isUserCity = () => {
    if (!profile?.city || !(profile?.city?.length > 0)) {
      return;
    }
    return bentoBrand?.locationNames?.includes(profile?.city?.toLowerCase());
  };

  const getContainerStyles = () => {
    const styles = {
      ml: -0.5,
      p: 0,
      mb: 0,
    };
    return styles;
  };

  const renderIcons = () => {
    return (
      <Grid
        item
        container
        xs="auto"
        alignItems="center"
        sx={getContainerStyles()}
      >
        {isUserCity() && (
          <Tooltip enterTouchDelay={0} title="Close to your city">
            <Box
              component="i"
              className="fa-solid fa-location-pin"
              sx={[styles.icon, styles.locationPin]}
            />
          </Tooltip>
        )}
        {hasPaidPartnership && (
          <Tooltip enterTouchDelay={0} title="Partners With Creators">
            <Box
              component="i"
              className="fa-solid fa-suitcase"
              sx={[styles.icon, styles.paidPartnershipBadge]}
            />
          </Tooltip>
        )}
        {worksWithUgc && (
          <Tooltip enterTouchDelay={0} title="Works with UGC creators">
            <Box
              component="i"
              className="fa-solid fa-tag"
              sx={[styles.icon, styles.worksWithUgcBadge]}
            />
          </Tooltip>
        )}
        {worksWithInfluencer && (
          <Tooltip enterTouchDelay={0} title="Works with Influencers">
            <Box
              component="i"
              className="fa-solid fa-hashtag"
              sx={[styles.icon, styles.worksWithInfluencer]}
            />
          </Tooltip>
        )}
        {worksWithPodcasters && (
          <Tooltip enterTouchDelay={0} title="Works with Podcasters">
            <Box>🎙️</Box>
          </Tooltip>
        )}
        {addedWithinLastWeek && (
          <Tooltip enterTouchDelay={0} title="Added within last week">
            <Box
              sx={[styles.icon, styles.bolt]}
              component="i"
              className="fa-solid fa-bolt"
            />
          </Tooltip>
        )}
        {hasTiktokAds && (
          <Tooltip enterTouchDelay={0} title="Runs TikTok Ads">
            <Box
              component="i"
              sx={[styles.icon, styles.tiktok]}
              className="fa-brands fa-tiktok"
            />
          </Tooltip>
        )}
        {hasAds && (
          <Tooltip enterTouchDelay={0} title="Has Ads">
            <Box
              component="i"
              sx={[styles.icon, styles.ads]}
              className="fa-solid fa-rectangle-ad"
            />
          </Tooltip>
        )}
        {noRecentContacts && (
          <Tooltip enterTouchDelay={0} title="Not contacted this week">
            <Box
              component="i"
              sx={[styles.icon, styles.star]}
              className="fa-solid fa-star"
            />
          </Tooltip>
        )}
        {hasNonGenericEmails && (
          <Tooltip enterTouchDelay={0} title="Has a direct contact">
            <Box
              component="i"
              sx={[styles.icon, styles.directContact]}
              className="fa-solid fa-user"
            />
          </Tooltip>
        )}
      </Grid>
    );
  };

  return renderIcons();
}
